import styles from "./CallToAction.module.css";
import { Link } from 'react-router-dom';

function CallToAction (props) {
    return (
        <section className={styles.cta}>
            <div className={styles.ctaInner}>
                <h2 className={styles.ctaHeading}>{ props.heading }</h2>
                <p className={styles.ctaText}>{ props.text }</p>
                <Link to="/registration" className={styles.ctaBtn}>Get started free →</Link>
            </div>
        </section>
    );
}

export default CallToAction;